export default __webpack_public_path__ + "static/media/6.68d2cf69.svg";